import { useTheme } from "@mui/material";

const SectionTitle = ({ title, children }) => {
  const theme = useTheme();
  return (
    <fieldset
      style={{
        border: `1px solid`,
        borderColor: theme.borderColor,
        borderRadius: 8,
        padding: "16px 16px 24px 16px",
        margin: 0,
        minWidth: 0,
      }}
    >
      <legend
        style={{
          padding: "0 12px",
          marginLeft: 10,
          fontSize: 16,
          fontWeight: 500,
          width: "auto",
        }}
      >
        {title}
      </legend>
      {children}
    </fieldset>
  );
};

export default SectionTitle;
